<template>
    <ui-button to="/login">{{ t('auth_login') }}</ui-button>
</template>

<script setup lang="ts">
    const { t } = useI18n()
</script>